var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"circle-loading"}},[_c('q-spinner',{attrs:{"color":"primary","size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }